// extracted by mini-css-extract-plugin
module.exports = {"MobileTrigger":"AwRul7","Drawer":"t_yV3m","MobileMenu":"FaEtcz","Navigation":"Nc92nK"};